<div class="card">
	<img [src]="compPhoto" class="card-img-top">
	<div class="card-body">
		<div class="row">
			<div class="col-md-6">
				<div class="table modal-table">
					<div class="row separator">
						<div class="col ">
							<h5 class="text-capitalize mb-0">{{this.data.comp || ''}}</h5>
						</div>
					</div>
					<div class="row"
						*ngFor="let row of calculatedData"
						[ngClass]="row.type || ''">
						<div class="col">{{row.header}}</div>
						<ng-container *ngIf="!(row.value | isArray) && row.type !== 'separator'">
							<div class="col-md-8">{{row.value}}</div>
						</ng-container>
						<ng-container *ngIf="row.value | isArray">
							<div class="d-flex flex-column justify-content-center"
								[ngClass]="{
									'col-md-4': row.value?.length === 2,
									'col-md-8': row.value.length <= 1
								}">
								{{row.value[0] || ''}}
							</div>
							<div *ngIf="row.value.length > 1"
								class="col-md-4 d-flex flex-column justify-content-center value-adjustment">
								{{row.value[1] || ''}}
							</div>
						</ng-container>

					</div>
				</div>
			</div>

			<div class="col-md-6">
				<div class="table modal-table">
					<div class="row separator">
						<div class="col">
							<h5 class="text-capitalize mb-0">Public Record</h5>
						</div>
					</div>
					<div class="row">
						<div class="col skip p-0">
							<cv-ci-public-record-list class="p-0"
								[publicRecord]="compPR">
							</cv-ci-public-record-list>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</div>
